import React from "react";
import { motion } from "framer-motion";
import { Shield, Lock, CheckCircle } from "lucide-react";
import idVerification from "/assets/id_ver.png";
import { useLanguage } from "@/context/LanguageContext";
import { indexLabels } from "@/i18n";

const PaymentSection = () => {
  const { language } = useLanguage();
  const labels = indexLabels(language);

  const paymentFeatures = [
    {
      icon: (
        <img
          src="/assets/BankID_logo.png"
          alt="BankID"
          className="h-4 w-auto object-contain"
        />
      ),
      title: labels.payment.feature1Title,
      desc: labels.payment.feature1Desc,
      bankId: true,
    },
    {
      icon: <Shield className="w-full h-full" />,
      title: labels.payment.feature2Title,
      desc: labels.payment.feature2Desc,
    },
    {
      icon: <CheckCircle className="w-full h-full" />,
      title: labels.payment.feature3Title,
      desc: labels.payment.feature3Desc,
    },
    {
      icon: <Lock className="w-full h-full" />,
      title: labels.payment.feature4Title,
      desc: labels.payment.feature4Desc,
    },
  ];

  return (
    <motion.div
      initial={{ opacity: 0, y: 20 }}
      whileInView={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.22 }}
      viewport={{ once: true }}
      className="relative overflow-hidden rounded-2xl w-full border border-white/20 shadow-xl transition-all duration-150 hover:shadow-2xl hover:border-white/25 bg-gradient-to-br from-violet-600 via-indigo-600 to-violet-800"
    >
      <div
        className="absolute inset-0 pointer-events-none opacity-20"
        style={{
          background:
            "radial-gradient(ellipse 120% 80% at 50% -5%, rgba(139,92,246,0.4), transparent 70%)",
        }}
      />
      <div className="relative flex flex-col md:flex-row items-stretch text-white">
        <div className="flex-1 p-4 md:p-5">
          <div className="mb-3">
            <h3 className="text-base md:text-lg font-bold text-white">
              {labels.payment.title}
            </h3>
          </div>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-4 md:gap-5 mb-3">
            {paymentFeatures.map((item, index) => (
              <div key={index} className="flex items-center gap-2">
                <div
                  className={
                    item.bankId
                      ? "flex h-8 w-8 flex-shrink-0 items-center justify-center rounded-full bg-white shadow-sm"
                      : "flex h-7 w-7 flex-shrink-0 items-center justify-center rounded-full border border-white/10 bg-white/15"
                  }
                >
                  {item.bankId ? (
                    item.icon
                  ) : (
                    <div className="h-4 w-4 text-white/90">{item.icon}</div>
                  )}
                </div>
                <div>
                  <h4 className="text-sm font-semibold text-white">
                    {item.title}
                  </h4>
                  <p className="text-xs text-white/75">{item.desc}</p>
                </div>
              </div>
            ))}
          </div>
        </div>

        <div className="relative flex-shrink-0 md:w-60 lg:w-72 xl:w-80">
          <img
            src={idVerification}
            alt="ID verification"
            className="h-full w-full object-cover object-center"
          />
          <div className="pointer-events-none absolute inset-0 bg-gradient-to-r from-zinc-900/90 via-zinc-900/40 to-transparent" />
        </div>
      </div>
    </motion.div>
  );
};

export default PaymentSection;
